import { get, put, del, post } from './requests'

const PERMISSION_SETS = 'permission-sets'
const PERMISSION_SET = 'permission-set'

export const getPermissionSets = () => get([PERMISSION_SETS], {})

export const getPermissionSet = (id) => get([PERMISSION_SETS, id])

export const updatePermissionSet = (id, data) => put([PERMISSION_SETS, id], {}, data)

export const deletePermissionSet = (id) => del([PERMISSION_SETS, id], {})

export const createPermissionSet = (data) => post([PERMISSION_SETS], {}, data)

export const setPermissionToUser = (permissionSetId, userId) =>
  put(['permissions', PERMISSION_SET, permissionSetId, 'user', userId], {
    removeTrailingSlash: true,
  })

export const addDatasphereAccess = (userId) =>
  put(['permissions', 'user', 'datasphere-access', userId], {})

export const addDatasphereAdmin = (userId) =>
  put(['permissions', 'user', 'datasphere-admin', userId], {})

export const getOrgs = () => get(['permissions', 'orgs'])

export const deleteUser = (userId) => del(['users', userId])

export const changeUserOrg = ({ id, org }) => put(['users', 'org', id], {}, { org })

export const getAllUsers = () => get('users/all')
